import { useConfigStore } from 'shared/store/configSlice'
import { SliderSelect } from 'entities/SliderSelect'
import { bookingPercentageOptions } from './options'

export const BookingLimitTR = () => {
  const bookingLimit = useConfigStore().config?.tableReservationConfig?.bookingLimitPercent
  const updateTableReservationConfig = useConfigStore().updateTableReservationConfig

  const updateBookingPercentage = (valueToSet: number) => {
    if (Number.isFinite(valueToSet)) {
      updateTableReservationConfig({ bookingLimitPercent: valueToSet })
    }
  }

  return (
    <SliderSelect
      key={`booking_limit_${bookingLimit}`}
      title='Booking web app limit'
      width='100%'
      onChange={updateBookingPercentage}
      marks={bookingPercentageOptions}
      step={10}
      defaultValue={bookingLimit}
    />
  )
}
